module.exports = __webpack_public_path__ + "images/videoCaseStudy-mandel-og.jpg?h=0691c8ddd668130902516d02fd44eacf";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-og.jpg
// module id = 1721
// module chunks = 12 15